"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "coreglia-antelminelli": {
    "6ef3ff13": [{
      "hkey": "052d7406",
      "slug": "coreglia-antelminelli",
      "name": "Coreglia Antelminelli",
      "primary": true,
      "skipSearch": false
    }],
    "calavorno": [{
      "hkey": "052d7406",
      "slug": "coreglia-antelminelli",
      "name": "Coreglia Antelminelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8157d00b": [{
      "hkey": "8523d78f",
      "slug": "piano-di-coreglia-ghivizzano",
      "name": "Piano di Coreglia-Ghivizzano",
      "primary": true,
      "skipSearch": false
    }],
    "ghivizzano": [{
      "hkey": "8523d78f",
      "slug": "piano-di-coreglia-ghivizzano",
      "name": "Piano di Coreglia-Ghivizzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "coreglia-antelminelli"
    }],
    "4750b8d3": [{
      "hkey": "8523d78f",
      "slug": "piano-di-coreglia-ghivizzano",
      "name": "Piano di Coreglia-Ghivizzano",
      "primary": true,
      "skipSearch": false
    }],
    "piano-di-coreglia": [{
      "hkey": "8523d78f",
      "slug": "piano-di-coreglia-ghivizzano",
      "name": "Piano di Coreglia-Ghivizzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;